import { Grid } from '@mui/material'

interface ComponentCatalogExampleProps {
  children: React.ReactNode
  name: string
}

export const ComponentCatalogExample = ({
  name,
  children,
}: ComponentCatalogExampleProps) => {
  return (
    <>
      <Grid item xs={12} sm={3} className="align-center justify-center">
        <pre className="font-bold">{name}</pre>
      </Grid>
      <Grid item xs={12} sm={9}>
        {children}
      </Grid>
    </>
  )
}
